import axios from '@/libs/http'

/**
 * 获取店员动态评论列表
 */
export const getClerkPostCommentList = (clerkPostId, pageNo, pageSize) => {
    return axios.request({
        url: '/s/c/clerkPostComment/list',
        params: {
            clerkPostId,
            pageNo,
            pageSize
        },
        method: 'get'
    })
}

/**
 * 展开评论
 */
export const expandComment = (commentId, pageNo, pageSize) => {
    return axios.request({
        url: '/s/c/clerkPostComment/expandComment',
        params: {
            commentId,
            pageNo,
            pageSize
        },
        method: 'get'
    })
}

/**
 * 添加评论
 */
export const addComment = (clerkPostId, content, replyCommentId) => {
    return axios.request({
        url: '/s/c/clerkPostComment/addComment',
        params: {
            clerkPostId,
            content,
            replyCommentId
        },
        method: 'get'
    })
}

/**
 * 删除评论
 */
export const deleteComment = (clerkPostCommentId) => {
    return axios.request({
        url: '/s/c/clerkPostComment/delete',
        params: {
            clerkPostCommentId
        },
        method: 'get'
    })
}

